import { cn } from '@optools/components/ui/utils';
import { ValidateLitmusSchemaMutation } from '@optools/services/operator-gateway/types/generated/graphql';

import { formatValidationProcessName } from '../utils/format-validation-process';

export interface ValidationSuiteFooterProps {
  result: ValidateLitmusSchemaMutation['validate'];
}

export function ValidationSuiteFooter({ result }: ValidationSuiteFooterProps) {
  return (
    <div className="flex min-h-14 items-center justify-end pr-2">
      {result ? (
        <dl className="ease flex animate-fade-in items-center gap-4 opacity-0 duration-200">
          <div>
            <dt className="inline font-light" id="validation-suite">
              Validation Suite:{' '}
            </dt>
            <dd aria-labelledby="validation-suite" className="inline font-bold">
              {formatValidationProcessName(result.validationProcess)}
            </dd>
          </div>

          <div>
            <dt className="inline font-light" id="validation-result">
              Validation Result:{' '}
            </dt>
            <dd
              aria-labelledby="validation-result"
              className={cn(
                'inline font-bold uppercase',
                result.isValid ? 'text-green-700' : 'text-red-600',
              )}>
              {result.isValid ? 'Pass' : 'Fail'}
            </dd>
          </div>
        </dl>
      ) : null}
    </div>
  );
}
